<template>
  <div>
     <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
            <p></p>
            <v-card>
              <!-- <v-alert class="text-left" dense outlined type="warning" v-if="!checkDataItemFamily" @click="GoFamily()">
                <u>ไม่พบการปรับปรุงข้อมูลครอบครัว กรุณาปรับปรุงก่อนเริ่มโครงการ <br> *ความถูกต้องของข้อมูล มีผลต่อการพิจารณาโครงการ</u>
              </v-alert>
              <v-alert class="text-left" dense outlined type="warning" v-if="!checkDataItemAddress" @click="GoUpdateAddress()">
                <u>ไม่พบการปรับปรุงข้อมูลที่อยู่อาศัย กรุณาปรับปรุงก่อนเริ่มโครงการ <br> *ความถูกต้องของข้อมูล มีผลต่อการพิจารณาโครงการ</u>
              </v-alert> -->
              <center>
                <!-- <v-btn
                v-if="dataEvent.length < 2"
                  color="light-blue darken-4"
                  block
                  dark
                  large
                  @click="dialog = true"
                >
                  ลงทะเบียน
                </v-btn> -->
              </center>
              <div class="pa-2 ma-2" v-if="dataEvent.length < 1">
                    <v-row align="center">
                      <v-col cols="12">
                        <h6 :class="` font-weight-bold grey--text`">
                          พบกับ Phase 3 ในเร็วๆนี้
                        </h6>
                      </v-col>
                    </v-row>
              </div>

              <div v-for="(items, index) in dataEvent" :key="index">
                <v-card
                  v-if="
                  items.campaignPhase == 'Phase 2' &&
                    items.eventStatus == 'waiting' &&
                    items.receivedItem == 'waiting'
                  "
                  class="mx-auto pa-2 ma-2"
                  max-width="400"
                >
                  <v-toolbar color="info" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title class="text-h5">
                          โครงการ วี กรุ๊ป ปันสุข
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>

                  <v-card-text class="pa-2 ma-2">
                    <v-row align="center">
                      <v-col cols="12">
                        <v-img
                          :src="imageRegis"
                          alt="Sunny image"
                          width="92"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text class="pa-0 ma-0">
                    <v-row align="center">
                      <v-col cols="12">
                        <h6 :class="` font-weight-bold indigo--text`">
                          ท่านได้ลงทะเบียนโครงการ วี กรุ๊ป ปันสุข
                        </h6>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-list class="pa-0 ma-0">
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        Phase
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ items.campaignPhase }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>

                  <v-list class="pa-0 ma-0">
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        Package
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ items.choosePackage }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>

                  <v-toolbar color="info" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title
                          >ลงทะเบียนเรียบร้อย</v-list-item-title
                        >
                        <v-list-item-title
                          >กรุณารอผลการอนุมัติโครงการ</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>
                </v-card>

                <v-card
                  v-if="
                  items.campaignPhase == 'Phase 2' &&
                    items.eventStatus == 'approve' &&
                    items.receivedItem == 'waiting'
                  "
                  class="mx-auto pa-2 ma-2"
                  max-width="400"
                >
                  <v-toolbar color="#C62929" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title class="text-h5">
                          โครงการ วี กรุ๊ป ปันสุข
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>

                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12">
                        <v-img
                          :src="imageRegisApprove"
                          alt="Sunny image"
                          width="92"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12">
                        <h5 :class="` font-weight-bold green--text`">
                          ท่านผ่านเงื่อนไขโครงการ
                        </h5>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-list class="pa-0">
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        Phase
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ items.campaignPhase }}
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        Package
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                         {{ items.choosePackage }}
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        วันที่มอบของ
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        21 กรกฎาคม - 25 กรกฎาคม
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                <v-toolbar color="#C62929" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>นำการ์ดนี้แสดงต่อเจ้าหน้าที่</v-list-item-title>
                        <v-list-item-title>ฝ่ายบุคคลประจำสาขาของท่าน</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>
                </v-card>

                <v-card
                  v-if="
                  items.campaignPhase == 'Phase 2' &&
                    items.eventStatus == 'unapprove' &&
                    items.receivedItem == 'waiting'
                  "
                  class="mx-auto pa-2 ma-2"
                  max-width="400"
                >
                  <v-toolbar color="#C62929" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title class="text-h5">
                          โครงการ วี กรุ๊ป ปันสุข
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>

                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12">
                        <v-img
                          :src="imageRegisunApprove"
                          alt="Sunny image"
                          width="92"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12">
                        <h5 :class="` font-weight-bold purple--text`">
                          ท่านไม่ผ่านเงื่อนไขโครงการ<br> {{ items.campaignPhase }}
                        </h5>
                        <v-list-item-title v-if="items.campaignPhase == 'Phase 1'">ลงทะเบียน Phase ถัดไปในวันที่ 1 กรกฎาคม 2565</v-list-item-title>
                        <v-list-item-title v-if="items.campaignPhase == 'Phase 2'">ลงทะเบียน Phase ถัดไปในวันที่ 1 สิงหาคม 2565</v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-card-text>

                <v-toolbar color="#C62929" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>@V Group Honda</v-list-item-title>
                        <!-- <v-list-item-title>รอการพิจารณารอบถัดไป</v-list-item-title> -->
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>
                </v-card>

                <v-card
                  v-if="
                    items.campaignPhase == 'Phase 2' &&
                    items.receivedItem == 'received' &&
                    items.eventStatus == 'approve'
                  "
                  class="mx-auto pa-2 ma-2"
                  max-width="400"
                >
                  <v-toolbar color="green darken-2" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title class="text-h5">
                          โครงการ วี กรุ๊ป ปันสุข
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>

                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12">
                        <v-img
                          :src="imageGive"
                          alt="Sunny image"
                          width="92"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12">
                        <h5 :class="` font-weight-bold deep-purple--text`">
                          ท่านได้รับของเรียบร้อย
                        </h5>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-list class="pa-0 ma-0">
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        Phase
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ items.campaignPhase }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>

                  <v-list class="pa-0 ma-0">
                    <v-list-item>
                      <v-list-item-title class="text-left">
                        Package
                      </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ items.choosePackage }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>

                  <v-toolbar color="green darken-2" dark>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>@V Group Honda</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-toolbar>
                </v-card>
              </div>
            </v-card>

            <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>ลงทะเบียน</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <!-- <v-subheader>User Controls</v-subheader> -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>1.โครงการ วี กรุ๊ป ปันสุข</v-list-item-title>
              <small>บริษัทฯ ขอมอบโครงการดี ๆ "วี.กรุ๊ป ปันสุข"ให้กับพี่น้อง ชาว วีกรุ๊ป ในภาวะวิกฤต ของเศรษฐกิจ
เป็นการมอบสิ่งของ อุปโภค บริโภค สิ่งจําเป็นในการดํารงชีพ
ให้กับพนักงาน และครอบครัว โดยพิจารณาตามลําดับ จากรายได้และความเดือดร้อนของพนักงาน</small>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>2.โครงการ มิถุนายน ถึง สิงหาคม 2565</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
                    <v-list-item>
            <v-list-item-content>
              <v-list-item-title>3.วิธีการพิจารณาและ/หรือดําเนินโครงการ</v-list-item-title>
              <small><li>3.1 พนักงานต้องลงทะเบียนในระบบ HRM เท่านั้น</li>
                      <li>
                        3.2
                        การพิจารณาโดยการจัดกลุ่มอัตราค่าจ้างรายได้ของพนักงานและความ
                        เดือดร้อนตามลําดับ
                      </li>
                      <li>
                        3.3 เครื่องอุปโภค บริโภค จะมี ข้าวสาร, มาม่า,
                        ปลากระป๋อง, น้ํามันพืช, คูปองแลกอิ่มหนึ่งมื้อ
                        กับร้านค้าที่ทางบริษัทติดต่อเท่านั้น
                      </li>
                      <li>
                        3.4 บริษัท จะมอบให้แก่พนักงานเดือนละ 1 ครั้ง
                      </li></small>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list
          three-line
          subheader
        >
          <v-subheader>เลือก Package</v-subheader>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="choosePackage" value="Package 1"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Package 1</v-list-item-title>
              <v-list-item-subtitle>แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="choosePackage" value="Package 2"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Package 2</v-list-item-title>
              <v-list-item-subtitle>แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="choosePackage"  value="Package 3"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Package 3</v-list-item-title>
              <v-list-item-subtitle>แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list
          three-line
          subheader
        >
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="checkbox"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>ฉันยินดีเข้าร่วมโครงการและลงทะเบียน</v-list-item-title>
              <v-col class="text-center">
              <v-list-item-subtitle>
                <br>
                <v-btn
                  color="primary"
                  v-if="checkbox && choosePackage !==''"
                  @click="approve()"
                >
                  บันทึกข้อมูล
                </v-btn></v-list-item-subtitle>
              </v-col>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-dialog>

          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {},
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      dataEvent: [],
      dialog: false,
      choosePackage: '',
      checkbox: false,
      // แพคเกจที่ 1 ข้าวสาร,มาม่า,ปลากระป๋อง,น้ำมันพืช//แพคเกจที่ 2 คูปองรับประทานอาหาร มูลค่า 400 บาท 8 ใบๆละ 50 บาท//แพคเกจที่ 3 Gift voucher Lotus มูลค่า 400 บาท
      packageItem: [
        { text: 'แพคเกจที่ 1', value: 'Package 1' },
        { text: 'แพคเกจที่ 2', value: 'Package 2' },
        { text: 'แพคเกจที่ 3', value: 'Package 3' }
      ],
      formAdd: [],
      hideInfo: true,
      dataReady: true,
      hideCheckinHistory: false,
      AccessKey: '',
      ApplicationKey: '',
      imageHeadHRM: '',
      imageUrlBack: '',
      imageRegis: '',
      imageRegisApprove: '',
      imageRegisunApprove: '',
      imageGive: '',
      checkDataItem: false,
      checkDataItemFamily: false,
      checkDataItemAddress: false,
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9'
      ]
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.dataReady = true
    this.profile = JSON.parse(localStorage.getItem('liff_info'))

    this.imageHeadHRM = require('@/assets/Cover_Line_Pansook.jpg')
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageRegis = require('@/assets/punsukEvent.png')
    this.imageRegisApprove = require('@/assets/LRpunsuk.jpg')
    this.imageGive = require('@/assets/give.png')
    this.imageRegisunApprove = require('@/assets/hug.png')
    // await this.getDataByFamily()
    // await this.getDataByAddress()
    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    GoFamily () {
      this.$router.push('/Liff/EmpFamily')
    },
    GoUpdateAddress () {
      this.$router.push('/Liff/EmpAddress')
    },
    async getData () {
      this.dataReady = false
      this.dataEvent = []
      // if (this.checkDataItemFamily && this.checkDataItemAddress) {
      const response = await axios
        .get(this.DNS_IP + '/event_punsuk/getEmpCode?empCode=' + this.profile.empCode, {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        })
        .catch(() => {
          this.dataReady = true
        })
        // console.log('getData', response)
      if (response.data) {
        // this.dataReady = false
        // this.checkDataItem = false
        this.dataEvent = response.data
      } else {
        // this.checkDataItem = true
      }
      // } else {
      //   this.dataReady = false
      // }
    },
    async getDataByFamily () {
      var response = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/event_punsuk/getDataFamily?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      console.log('getDataByFamily', response.data)
      if (response.data) {
        this.checkDataItemFamily = true
      }
    },
    async getDataByAddress () {
      var response = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/event_punsuk/getDataAddress?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      console.log('getDataByAddress', response.data)
      if (response.data) {
        this.checkDataItemAddress = true
      }
    },
    approve () {
      this.dataReady = true
      console.log('profile', this.profile)
      let ds = {
        empCode: this.profile.empCode,
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName,
        campaignPhase: 'Phase 2',
        choosePackage: this.choosePackage

      }
      console.log('ds', ds)
      this.addData(ds)
    },
    async addData (ds) {
      this.dialog = false
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/event_punsuk/add",
          ds
        )
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'ลงทะเบียน เรียบร้อย', 'success')
          this.dialog = false
          this.dataReady = false
          await this.getData()
          await this.liffSendRegister(ds)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async liffSendRegister (item) {
      if (this.$liff.getContext().type !== 'none' && this.$liff.getContext().type !== 'external') {
        await this.$liff.sendMessages([

          {
            'type': 'flex',
            'altText': 'ลงทะเบียนโครงการเรียบร้อย',
            'contents': {
              'type': 'bubble',
              'size': 'giga',
              'header': {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'โครงการ วี กรุ๊ป ปันสุข',
                    'align': 'center',
                    'color': '#ffffff',
                    'size': '20px',
                    'style': 'normal'
                  }
                ]
              },
              'hero': {
                'type': 'image',
                'url': 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fhands.png?alt=media&token=1bb7fb99-42e4-4895-af0f-1a9d7839b88e',
                'size': 'full',
                'aspectRatio': '20:13',
                'aspectMode': 'fit',
                'align': 'center'
              },
              'body': {
                'type': 'box',
                'layout': 'vertical',
                'spacing': 'none',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'ท่านได้ลงทะเบียนโครงการ วี กรุ๊ป ปันสุข',
                    'wrap': true,
                    'weight': 'bold',
                    'gravity': 'center',
                    'size': 'xl',
                    'align': 'center'
                  },
                  {
                    'type': 'box',
                    'layout': 'vertical',
                    'margin': 'lg',
                    'spacing': 'sm',
                    'contents': [
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'spacing': 'sm',
                        'contents': [
                          {
                            'type': 'text',
                            'text': 'ชื่อ',
                            'color': '#aaaaaa',
                            'size': 'xs',
                            'flex': 1
                          },
                          {
                            'type': 'text',
                            'text': this.profile.empFull_NameTH,
                            'wrap': true,
                            'size': 'sm',
                            'color': '#001580',
                            'flex': 0
                          }
                        ]
                      },
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'spacing': 'sm',
                        'contents': [
                          {
                            'type': 'text',
                            'text': 'Phase',
                            'color': '#aaaaaa',
                            'size': 'sm',
                            'flex': 1
                          },
                          {
                            'type': 'text',
                            'text': item.campaignPhase,
                            'wrap': true,
                            'color': '#001580',
                            'size': 'sm',
                            'flex': 0
                          }
                        ]
                      },
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'spacing': 'xxl',
                        'contents': [
                          {
                            'type': 'text',
                            'text': 'Package',
                            'color': '#aaaaaa',
                            'size': 'sm',
                            'flex': 1
                          },
                          {
                            'type': 'text',
                            'text': item.choosePackage,
                            'wrap': true,
                            'color': '#001580',
                            'size': 'sm',
                            'flex': 0
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              'footer': {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'ลงทะเบียนเรียบร้อย',
                    'size': '14px',
                    'align': 'center',
                    'color': '#ffffff',
                    'wrap': true
                  },
                  {
                    'type': 'text',
                    'text': 'กรุณารอผลการอนุมัติโครงการ',
                    'size': '14px',
                    'align': 'center',
                    'color': '#ffffff',
                    'wrap': true
                  },
                  {
                    'type': 'text',
                    'text': '@V Group Honda',
                    'size': '14px',
                    'align': 'center',
                    'color': '#ffffff'
                  }
                ]
              },
              'styles': {
                'header': {
                  'backgroundColor': '#62a4f5'
                },
                'footer': {
                  'backgroundColor': '#62a4f5'
                }
              }
            }
          }
        ])
      }
    },
    async updateReceived (item) {
      this.$swal({
        title: 'ต้องการ ยืนยัน การรับของ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async () => {
          this.dataReady = true
          let data = {
            receivedItem: 'received'
          }
          await this.updateStatus(item, data)
          await this.getData()
          await this.liffSendReceived(item)
        })
        .catch(() => {
          this.dataReady = true
        })
    },
    async updateStatus (element, data) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/event_punsuk/edit/" + element.id,
          data,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(() => {
          console.log('element', element.eventStatus)
        })
    },
    async liffSendReceived (item) {
      if (this.$liff.getContext().type !== 'none' && this.$liff.getContext().type !== 'external') {
        await this.$liff.sendMessages([

          {
            'type': 'flex',
            'altText': 'รับของเรียบร้อย',
            'contents': {
              'type': 'bubble',
              'size': 'giga',
              'header': {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'โครงการ วี กรุ๊ป ปันสุข',
                    'align': 'center',
                    'color': '#ffffff',
                    'size': '20px',
                    'style': 'normal'
                  }
                ]
              },
              'hero': {
                'type': 'image',
                'url': 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fgive.png?alt=media&token=aa7b0707-4a3a-4f69-971e-4245e3b02777',
                'size': 'full',
                'aspectRatio': '20:13',
                'aspectMode': 'fit',
                'action': {
                  'type': 'uri',
                  'uri': 'http://linecorp.com/'
                },
                'align': 'center'
              },
              'body': {
                'type': 'box',
                'layout': 'vertical',
                'spacing': 'none',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'ท่านได้รับของเรียบร้อย',
                    'wrap': true,
                    'weight': 'bold',
                    'gravity': 'center',
                    'size': '26px',
                    'color': '#00ab06',
                    'align': 'center'
                  },
                  {
                    'type': 'box',
                    'layout': 'vertical',
                    'margin': 'lg',
                    'spacing': 'sm',
                    'contents': [
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'spacing': 'sm',
                        'contents': [
                          {
                            'type': 'text',
                            'text': 'ชื่อ',
                            'color': '#aaaaaa',
                            'size': 'xs',
                            'flex': 1
                          },
                          {
                            'type': 'text',
                            'text': this.profile.empFull_NameTH,
                            'wrap': true,
                            'size': 'sm',
                            'color': '#001580',
                            'flex': 0
                          }
                        ]
                      },
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'spacing': 'sm',
                        'contents': [
                          {
                            'type': 'text',
                            'text': 'Phase',
                            'color': '#aaaaaa',
                            'size': 'sm',
                            'flex': 1
                          },
                          {
                            'type': 'text',
                            'text': item.campaignPhase,
                            'wrap': true,
                            'color': '#001580',
                            'size': 'sm',
                            'flex': 0
                          }
                        ]
                      },
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'spacing': 'xxl',
                        'contents': [
                          {
                            'type': 'text',
                            'text': 'Package',
                            'color': '#aaaaaa',
                            'size': 'sm',
                            'flex': 1
                          },
                          {
                            'type': 'text',
                            'text': item.choosePackage,
                            'wrap': true,
                            'color': '#001580',
                            'size': 'sm',
                            'flex': 0
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              'footer': {
                'type': 'box',
                'layout': 'vertical',
                'contents': [
                  {
                    'type': 'text',
                    'text': 'อย่าลืมล้างมือ สวมหน้ากากอนามัย',
                    'size': '14px',
                    'align': 'center',
                    'color': '#ffffff'
                  },
                  {
                    'type': 'text',
                    'text': '@V Group Honda',
                    'size': '14px',
                    'align': 'center',
                    'color': '#ffffff'
                  }
                ]
              },
              'styles': {
                'header': {
                  'backgroundColor': '#001580'
                },
                'footer': {
                  'backgroundColor': '#001580'
                }
              }
            }
          }
        ])
      }
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/RegisterEvent.vue